import { useState } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import "./searchfield.css";

export default function Searchfield(props) {
  const [textType, setTextType] = useState(props.type);
  return (
    <div className="search-input">
      <input
        type={textType}
        placeholder={props.placeholder}
        id={props.id}
        onChange={props.setState}
        value={props.value}
        autoComplete="off"
        className={props.classname}
        onKeyUp={props.onKeyUp}
      />
      <label htmlFor={props.id}>{props.label}</label>
      {props.password &&
        (textType == "password" ? (
          <AiFillEye
            className="pass-icon"
            onClick={() => setTextType("text")}
          />
        ) : (
          <AiFillEyeInvisible
            className="pass-icon"
            onClick={() => setTextType("password")}
          />
        ))}
    </div>
  );
}
